import {
  Crosshair, Package, FileText, ShoppingCart, Users, Megaphone, Newspaper, Receipt, Monitor,
  BarChart3, ArrowLeftRight, Truck, Search, Settings, Store, Map, Smartphone, Globe, CreditCard,
  Cpu, Landmark, Boxes, Rocket, Vault, Wrench, Sparkles, Star,
} from 'lucide-react';

export const WAR_ROOM = { path: '/admin', icon: Crosshair, label: 'War Room' };

export const MENU_GROUPS = [
  {
    key: 'ops', label: 'Operaciones y Ventas', icon: ShoppingCart,
    items: [
      { path: '/admin/orders', icon: ShoppingCart, label: 'Órdenes' },
      { path: '/admin/requests', icon: FileText, label: 'Solicitudes', basic: true },
      { path: '/admin/shipping', icon: Truck, label: 'Envíos', basic: true },
      { path: '/admin/delivery-drivers', icon: Truck, label: 'Repartidores' },
      { path: '/admin/warroom', icon: Map, label: 'Mapa en vivo' },
    ],
  },
  {
    key: 'market', label: 'Ecosistema de Mercado', icon: Boxes,
    items: [
      { path: '/admin/products', icon: Package, label: 'Productos' },
      { path: '/admin/stores', icon: Store, label: 'Tiendas' },
      { path: '/admin/reviews', icon: Star, label: 'Reseñas' },
      { path: '/admin/users', icon: Users, label: 'Usuarios' },
    ],
  },
  {
    key: 'growth', label: 'Crecimiento y Contenido', icon: Rocket,
    items: [
      { path: '/admin/marketing', icon: Sparkles, label: 'Marketing' },
      { path: '/admin/ads', icon: Megaphone, label: 'Publicidad' },
      { path: '/admin/seo', icon: Globe, label: 'SEO' },
      { path: '/admin/search-engine', icon: Search, label: 'Motor de Búsqueda' },
      { path: '/admin/blog', icon: Newspaper, label: 'Blog', basic: true },
      { path: '/admin/cms', icon: Monitor, label: 'CMS', basic: true },
    ],
  },
  {
    key: 'treasury', label: 'Tesorería', icon: Vault,
    items: [
      { path: '/admin/payments', icon: CreditCard, label: 'Pagos' },
      { path: '/admin/bank', icon: Landmark, label: 'Banco' },
      { path: '/admin/taxes', icon: Receipt, label: 'Impuestos', basic: true },
    ],
  },
  {
    key: 'eng', label: 'Ingeniería y Sistema', icon: Wrench,
    items: [
      { path: '/admin/intelligence', icon: BarChart3, label: 'Inteligencia' },
      { path: '/admin/algorithms', icon: Cpu, label: 'Algoritmos' },
      { path: '/admin/import-export', icon: ArrowLeftRight, label: 'Importar / Exportar', basic: true },
      { path: '/admin/app-config', icon: Smartphone, label: 'App' },
      { path: '/admin/settings', icon: Settings, label: 'Configuración General', basic: true },
      { path: '/admin/preferences', icon: Globe, label: 'Preferencias' },
    ],
  },
];

export const isPathActive = (pathname, path) =>
  path === '/admin' ? pathname === '/admin' : pathname === path || pathname.startsWith(`${path}/`);

export const findGroupKey = (pathname) =>
  MENU_GROUPS.find(g => g.items.some(i => isPathActive(pathname, i.path)))?.key || null;
